// метод stringify запаковує дані у рядок
const age = 18
const films = [
    "Terrifier 1", "Terrifier 2", "Terrifier 3",
    "Saw 1", "Saw 2", "Saw 3", "Saw 4", "Saw 5",
    "Saw 6", "Saw 7", "Saw 8", "Saw 9", "Saw 10"
];
const archivedAge = JSON.stringify(age);
console.log(archivedAge, typeof(archivedAge));
const archivedFilms = JSON.stringify(films);
console.log(archivedFilms, typeof(archivedFilms));


// метод parse розпаковує дані з рядка
const parsedAge = JSON.parse(age);
console.log(parsedAge, typeof(parsedAge));
const parsedFilms = JSON.parse(films);
console.log(parsedFilms, typeof(parsedFilms));